(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-specifications"]) return;
  try {
    
(function () {
  if (window.__productSpecsVariantListener) return;
  window.__productSpecsVariantListener = true;

  var controllers = new WeakMap();

  function refreshProductSpecs(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-product-specs]').forEach(function (el) {
      var sectionId = el.dataset.sectionId;
      var productUrl = el.dataset.url;
      if (!sectionId || !productUrl) return;

      var prev = controllers.get(el);
      if (prev) prev.abort();
      var controller = new AbortController();
      controllers.set(el, controller);

      var separator = productUrl.indexOf('?') >= 0 ? '&' : '?';
      var fetchUrl = productUrl + separator + 'variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Section fetch failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-product-specs][data-section-id="' + sectionId + '"]')
            || doc.querySelector('[data-product-specs]');
          if (!incoming) return;

          el.innerHTML = incoming.innerHTML;
          if (incoming.getAttribute('style')) {
            el.setAttribute('style', incoming.getAttribute('style'));
          } else {
            el.removeAttribute('style');
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
        });
    });
  }

  document.addEventListener('on:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    refreshProductSpecs(variant.id);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
